import { tokenKey } from '@/config';
import Cookie from './cookie';
import store from '@/store';

function getToken() {
  return Cookie.get(tokenKey);
}

function setToken(token) {
  store.dispatch('setToken', token);
  return Cookie.set(tokenKey, token);
}

function removeToken() {
  return Cookie.remove(tokenKey);
}

export {
  getToken,
  setToken,
  removeToken
};